/// <reference path="../../../Modules/Attr/Grid/NoboxEntityGrid.ts" />
namespace Nobox.NoBoxCRM {

    @Serenity.Decorators.registerClass()
    export class FormGrid extends NoboxEntityGrid<FormRow, any> {
        protected getColumnsKey() { return FormColumns.columnsKey; }
        protected getDialogType() { return FormDialog; }
        protected getIdProperty() { return FormRow.idProperty; }
        protected getInsertPermission() { return FormRow.insertPermission; }
        protected getLocalTextPrefix() { return FormRow.localTextPrefix; }
        protected getService() { return FormService.baseUrl; }
        constructor(container: JQuery) {
            super(container);
            Q.serviceCall({
                blockUI: true,
                url: "/services/" + FormService.baseUrl + "/Retrieve",
                request: {
                    EntityId: 0,
                },
                onSuccess: (res: Serenity.RetrieveResponse<FormRow>) => {
                    $("#formSettingData").val(JSON.stringify(res.Entity));
                }
            })
        }

        protected getColumns(): Slick.Column[] {
            var columns = super.getColumns();
            columns.unshift({
                field: 'Analytics',
                name: '',
                format: ctx => {
                    return '<a href="javascript:;" title="Preview" class="analytics"><i class="fa fa-chart-bar text-danger analytics"></i></a>';
                },
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });
            columns.unshift({
                field: 'Action View',
                name: '',
                format: ctx => {
                    return '<a href="javascript:;" title="Preview"><i class="fa fa-search text-primary form-preview"></i></a>';
                },
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });
            const formaterType = Q.first(columns, x => x.field == FormRow.Fields.Type).format;
            const formaterLayout = Q.first(columns, x => x.field == FormRow.Fields.Layout).format;
            Q.first(columns, x => x.field == FormRow.Fields.Type).format =
                ctx => `<a href="javascript:;" class="form-type">${formaterType(ctx)}</a>`;
            Q.first(columns, x => x.field == FormRow.Fields.Product).format =
                ctx => `<a href="javascript:;" class="form-product">${Q.htmlEncode(ctx.value)}</a>`;
            Q.first(columns, x => x.field == FormRow.Fields.Layout).format =
                ctx => `<a href="javascript:;" class="form-layout">${formaterLayout(ctx)}</a>`;
            Q.first(columns, x => x.field == FormRow.Fields.Results).format =
                ctx => `<a href="javascript:;" class="form-results">${Q.htmlEncode(ctx.value)}</a>`;
            return columns;
        }
        protected getQuickFilters() {
            var flt = super.getQuickFilters();
            var filter2 = Q.first(flt, x => x.field == FormresultsRow.Fields.TagIds);
            filter2.handler = h => {
                const request = (h.request as FormresultsListRequest);
                const values = (h.widget as Serenity.ServiceLookupEditor).values;
                if (h.active) {
                    request.Tags = values.map(x => x);
                    h.handled = true;
                } else {
                    request.Tags = [];
                    h.handled = true;
                }
            };

            return flt;
        }
        protected onClick(e: JQueryEventObject, row: number, cell: number): void {

            // let base grid handle clicks for its edit links
            super.onClick(e, row, cell);
            // if base grid already handled, we shouldn"t handle it again
            if (e.isDefaultPrevented()) {
                return;
            }

            // get reference to current item
            var item = this.itemAt(row);

            // get reference to clicked element
            var target = $(e.target);

            if (target.hasClass("form-preview")) {
                window.open(`/form/${$("#dataUser").attr("data")}-${item.Id}`)
            } else if (target.hasClass("form-type")) {
                e.preventDefault();

                Q.notifySuccess("Success filter by type");
                var formFilter = this.findQuickFilter(Serenity.EnumEditor,
                    FormRow.Fields.Type);
                formFilter.set_value(item.Type.toString());
                this.refresh();
            } else if (target.hasClass("form-type")) {
                e.preventDefault();

                Q.notifySuccess("Success filter by type");
                var formFilter = this.findQuickFilter(Serenity.EnumEditor,
                    FormRow.Fields.Type);
                formFilter.set_value(item.Type.toString());
                this.refresh();
            } else if (target.hasClass("form-layout")) {
                e.preventDefault();

                Q.notifySuccess("Success filter by layout");
                var formFilter = this.findQuickFilter(Serenity.EnumEditor,
                    FormRow.Fields.Layout);
                formFilter.set_value(item.Layout.toString());
                this.refresh();
            } else if (target.hasClass("form-product")) {
                e.preventDefault();

                Q.notifySuccess("Success filter by product");
                var formsFilter = this.findQuickFilter(Serenity.ServiceLookupEditor,
                    FormRow.Fields.ProductId);
                formsFilter.set_value(item.ProductId.toString());
                this.refresh();
            } else if (target.hasClass("tags-link")) {
                e.preventDefault();

                Q.notifySuccess("Success filter by tags");
                var tagsFilter = this.findQuickFilter(Serenity.ServiceLookupEditor,
                    FormRow.Fields.TagIds);
                tagsFilter.set_value(tagsFilter.get_value() + "," + target.text());
                this.refresh();
            } else {
                if (target.hasClass("analytics")) {
                    //var dlg = new AnalyticsDialog();
                    //dlg.loadByIdAndOpenDialog(item.Id);
                    window.open(`/Form/Analytics?form=${item.Id}`)
                } else if (target.hasClass("form-results")) {
                    window.location.href = `/Form/Results?form=${item.Id}`;
                }
            }
        }

        protected getButtons() {
            var $this = this;
            var buttons = super.getButtons();
            var titleExport = $(document).width() < 576 ? "" : "Export Form";
            buttons.push({
                separator: true,
                title: titleExport,
                hint: "Export Form",
                icon: "fa-upload text-green",
                onClick: () => {

                    var link = document.createElement('a');
                    link.href = Q.resolveUrl(`~/Services/NoBoxCRM/Form/DownloadJson`);
                    link.click();
                }
            });
            var titleExcel = $(document).width() < 576 ? "" : "Import Form";
            buttons.push({
                separator: false,
                title: titleExcel,
                hint: "Import Form",
                icon: "fa-download text-green",
                onClick: () => {
                    // open import dialog, let it handle rest
                    var dialog = new JsonImportDialog();
                    dialog.grid = $this;
                    dialog.element.on('dialogclose', () => {
                        $this.refresh();
                        dialog = null;
                    });
                    dialog.dialogOpen();
                }
            });
            return buttons;
        }
        protected onViewSubmit(): boolean {
            if (!super.onViewSubmit()) { return false; }
            let request = this.view.params as Serenity.ListRequest;
            request.IncludeColumns.push("ProductId")
            //request.ColumnSelection = 1;
            return true;
        }
    }
}